<template>
    <div class="mp-multi-progress">
        <div class="mp-multi-progress__fix body-1">
            0
        </div>
        <div class="mp-multi-progress__bar-container">
            <div class="mp-multi-progress__bar" v-if="key !== 'sum_points'" v-for="(index, key) in items" :style="{ width: `${calcPercent(key)}%`, backgroundColor: attributeColorMapping[key] }"></div>
        </div>
        <div class="mp-multi-progress__fix body-1">
            {{ percent }}
        </div>
    </div>
</template>
<script>
export default {
    name: 'mp-multi-progress',
    props: {
        percent: {},
        items: {},
        attributeColorMapping: {},
    },
    methods: {
        calcPercent(key) {
            const calc = this.items[key] / this.percent * 100;
            return calc > 100 ? 100 : Math.round(calc);
        },
    },
};
</script>
